import * as React from "react";
import { connect } from "react-redux";

import { expire } from "../actions";
import { Message } from "../types";

import { RootDispatch, RootState } from "../../types";
import "./FlashProvider.scss";

interface StateProps {
  messages: Message[];
}

interface DispatchProps {
  dismiss: (messageId: string) => void;
}

const classForLevel = (level: string): string => {
  switch (level) {
    case "warn":
      return "alert-warning";
    case "error":
      return "alert-danger";
    default:
      return "alert-success";
  }
};

const FlashMessage = ({
  message,
  dismiss
}: {
  message: Message;
  dismiss: (messageId: string) => void;
}) => (
  <div className="flash-message">
    <div role="alert" className={`alert ${classForLevel(message.level)}`}>
      {message.body}
      <div className="actions">
        <button className="btn btn-link" onClick={() => dismiss(message.id)}>
          <i className="fas fa-fw fa-times" />
        </button>
      </div>
    </div>
  </div>
);

const FlashProvider = ({ messages, dismiss }: StateProps & DispatchProps) => (
  <div className="flash-provider">
    {messages.map(msg => (
      <FlashMessage message={msg} key={msg.id} dismiss={dismiss} />
    ))}
  </div>
);

export default connect(
  (state: RootState): StateProps => ({
    messages: state.flash.messages
  }),
  (dispatch: RootDispatch): DispatchProps => ({
    dismiss: msgId => dispatch(expire(msgId))
  })
)(FlashProvider);
